module.exports = __webpack_public_path__ + "static/img/intermediate_class.ee92c1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/intermediate_class.png
// module id = sHuQ
// module chunks = 1